import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OffboardingClient } from 'src/app/shared/models/offboarding/offboarding-client';
import { OffboardingClientStep } from 'src/app/shared/models/offboarding/offboarding-client-step';
import { OffboardingService } from 'src/app/services/offboarding.service';
import { OffboardingStepChanged } from 'src/app/shared/models/offboarding/offboarding-step-changed';
import { HttpErrorResponse } from '@angular/common/http';
import { OffboardingClientCategory } from 'src/app/shared/models/offboarding/offboarding-client-category';
import { SettingsService } from 'src/app/services/settings.service';
import { Note } from 'src/app/shared/models/note/note';

@Component({
  selector: 'app-offboarding-categories-steps',
  templateUrl: './offboarding-categories-steps.component.html',
  styleUrls: ['./offboarding-categories-steps.component.scss'],
})
export class OffboardingCategoriesStepsComponent implements OnInit {
  @Input() offboardingClient: OffboardingClient;
  @Output() stepNoteAdded = new EventEmitter<Note>();

  errorResponse: HttpErrorResponse;
  showError: boolean = false;
  updatedByUserId: number;
  updatedByUserName: string;

  constructor(
    private offboardingService: OffboardingService,
    private settingsService: SettingsService
  ) {
    this.updatedByUserId = this.settingsService.user.id;
    this.updatedByUserName = this.settingsService.userProfile.displayName;
  }

  ngOnInit(): void {}

  toggleStepUpdate(step: OffboardingClientStep) {
    step.isUpdating = true;
    step.recentlyUpdated = false;
    step.updateSuccess = false;
    step.error = null;

    this.offboardingService.UpdateStep(this.offboardingClient.userId, step.id, step.isCompleted, this.updatedByUserId).subscribe({
      next: (response: OffboardingStepChanged) => {
        step.recentlyUpdated = true;
        setTimeout(() => {
          step.recentlyUpdated = false;
        }, 3000);
        this.addStepNote(step);
      },
      error: (error) => {
        this.errorResponse = error;
        step.error = error;
        step.isCompleted = !step.isCompleted;
        this.showError = true;
        step.isUpdating = false;
      },
      complete: () => {
        step.isUpdating = false;
      },
    });
  }

  onCategoryClick(category: OffboardingClientCategory) {
    category.showSteps = !category.showSteps;
  }

  popupError(error: HttpErrorResponse) {
    this.errorResponse = { ...error };
    this.showError = true;
  }

  private addStepNote(step: OffboardingClientStep) {
    const notePrefix = step.isCompleted ? 'Completed:' : 'Reverted:';

    let addedNote: Note = new Note();
    addedNote.id = 0;
    addedNote.clientId = this.offboardingClient.userId;
    addedNote.note = `${notePrefix} ${step.description}`;
    addedNote.dateTimeCreated = new Date();
    addedNote.createdByUserId = this.updatedByUserId;
    addedNote.createdByUserFullName = this.updatedByUserName;

    this.stepNoteAdded.emit(addedNote);
  }
}
